<template>
  <div class="min-vh-100 d-flex justify-content-center align-items-center">
    <div v-if="!apiStatus" class="text-center">
  <h4 class="text-danger">Please contact admin</h4>
</div>
    <div  v-else class="card shadow p-4 w-50 rounded cursor-pointer" @click="triggerFileInput" >
      <div class="d-flex flex-column justify-content-center align-items-center">
        <form class="dropzone dz-clickable" @submit.prevent>
          <input type="file" ref="fileInput" class="d-none" multiple @change="UploadDoc" />
          <div class="dz-message needsclick padding-x text-primary text-center">
            <i class="h1 text-primary fas fa-cloud-upload-alt mb-2"></i>
            <h5 class="text-primary">Browse Files to upload</h5>
          </div>
        </form>
        <div class="dropzone-previews mt-3 w-100" id="file-previews">
          <div v-for="(file, index) in Obj.Images" :key="index" class="d-flex align-items-center justify-content-between border rounded p-2 mb-2" >
            <img :src="file.previewUrl" alt="preview" class="rounded me-2 object-fit-cover avatar-sm" />
            <div class="flex-grow-1">
              <div class="fw-bold text-truncate">{{ file.name }}</div>
              <small class="text-muted">{{ formatFileSize(file.size) }}</small>
            </div>
            <i role="button" @click.stop="removeFile(index)" class="fa-solid fa-x text-secondary ms-2 me-2" ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import {  api } from '@/utils/helpers.js';
import { useFileUpload } from "@/utils/fileUpload";
const { handleFileUploadDoc } = useFileUpload();
const Obj = ref({ Images: [] });
const fileInput = ref(null);
const apiStatus = ref(false);
const triggerFileInput = () => {
  fileInput.value.click();
};

const UploadDoc = async (event) => {
  const files = event.target.files;
  for (let i = 0; i < files.length; i++) {
    const rawFile = files[i];
    const uploadedFile = await handleFileUploadDoc(rawFile);
    if (uploadedFile) {
      Obj.value.Images.push({
        url: uploadedFile,
        previewUrl: URL.createObjectURL(rawFile),
        name: rawFile.name,
        size: rawFile.size,
      });
    }
  }
  event.target.value = "";
};

const removeFile = async (index) => {
  const file = Obj.value.Images[index];
  if (!file || !file.name) return;

  try {
   await api.delete(`/documents/students?filename=${file.url}`);
    Obj.value.Images.splice(index, 1);

  } catch (err) {
    console.error("Delete failed:", err);
  }
};


const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + " B";
  else if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  else return (bytes / (1024 * 1024)).toFixed(1) + " MB";
};
const loadDocAccessStatus = async () => {
    const res = await api.get(`/docaccess`);
    apiStatus.value = res.data.status;
};
onMounted(async () => {
 loadDocAccessStatus();
});
</script>
<style>
.padding-x{
  padding-right: 11rem !important;
    padding-left: 11rem !important;
}
@media (max-width: 560px) {
  .padding-x{
  padding-right: 1rem !important;
    padding-left: 1rem !important;
}
.dropzone .dz-message {
   margin: 0 0 !important; 
}
.w-50{
  width:100% !important;
}
}
</style>